import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../Context/UserContext";
import Button from "../../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../../Reusable/BaseURL";
import IndentStatusView from "../../../purchaseFormPages/IndentStatusView";
import { PartySelect } from "../../../Reusable/PartySelect";
import { Link, useNavigate } from "react-router-dom";
import { GenEIndentSelect } from "./GenEIndentSelect";
import { GenEPartySelect } from "./GenEPartySelect";

export default function GenerateEnquiry() {
  const { darkTheme, loginData, setIndentCreateItemId4Upd } =
    useContext(UserContext);

  const [indent, setIndent] = useState("");
  const [party, setParty] = useState("");
  const [enquiryIndent, setEnquiryIndent] = useState([]);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(false);

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);

  const [unsavedIndentItem, setUnsavedIndentItem] = useState([]);

  const navigate = useNavigate();

  // create
  const selectedPartyId = party && party.map((item, index) => item.value);
  async function createDivision(e) {
    e.preventDefault();

    setSubmitDisable(true);
    const formData = {
      indent_id: indent.value,
      party_id: selectedPartyId,
    };

    const res = await fetch(`${BaseURL}/purchase/enquiry/save`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // getUnsavedItemList();
          toast.success("Success");
          setEnquiryIndent([]);
          setParty("");
          setIndent("");
          navigate("/purchase/view-enquiry");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          toast.error("Indent & party required");
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/states?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setFrom(li.data.from);
          setTo(li.data.to);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(id) {
    fetch(`${BaseURL}/purchase/indent/getcacheitem/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          setChangingSelect(true);
          setSubmitAction("update");

          // setDivision(selectedRecord.data.division || "");
        }
      });
    setChangingSelect(false);
  }

  // GET INDENT
  const getIndent = async (id) => {
    // const response = await fetch(`${BaseURL}/purchase/indent/get/${id}`, {
    const response = await fetch(`${BaseURL}/purchase/indent/getapproved/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    });
    const data = await response.json();
    if (data.status) {
      setEnquiryIndent(data.data.items);
    }
  };

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");
    setEnquiryIndent([]);
    setParty("");
    setIndent("");
  }
  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Generate Enquiry
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col gap-8 md:gap-1 lg:gap-4"
          >
            <div className="px-2 mb-6 flex w-full flex-wrap justify-between">
              <form>
                <div className="flex flex-wrap gap-x-2 md:gap-x-6 gap-y-2">
                  <div className="mb-2 min-w-[260px] max-w-[500px]">
                    <label>Indent <span className="text-red-500 font-bold">*</span></label>
                    <GenEIndentSelect
                      selectedOption={indent}
                      setSelectedOption={setIndent}
                      changingSelect={changingSelect}
                      getIndent={getIndent}
                      setEnquiryIndent={setEnquiryIndent}
                    />
                  </div>

                  <div className="flex flex-wrap gap-2">
                    <div className="min-w-[260px] max-w-[800px]">
                      <label>Party <span className="text-red-500 font-bold">*</span></label>
                      <GenEPartySelect
                        selectedOption={party}
                        setSelectedOption={setParty}
                        changingSelect={changingSelect}
                      />
                    </div>
                  </div>
                </div>
              </form>
              <div>
                <Link to="/master/supplier" target="_blank">
                  <button className="bg-green-600 rounded-md px-4 py-2 text-white md:mt-5 md:ml-3 mt-2">
                    Create Party
                  </button>
                </Link>
              </div>
            </div>

            <div className="w-full px-2">
              <IndentStatusView
                editBtn={editBtn}
                // firstPageList={firstPageList}
                links={links}
                firstPage={enquiryIndent}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                addMoreToggle={addMoreToggle}
                setAddMoreToggle={setAddMoreToggle}
              />
            </div>

            {submitAction === "submit" && (
              <div className="flex items-center justify-center gap-x-1 mt-2">
                <Button
                  type="submit"
                  disabled={submitDisable}
                  onClick={(e) => createDivision(e)}
                >
                  {submitDisable ? "Wait.." : "Send"}
                </Button>
                <Button type="button" onClick={() => cancelUpdate()}>
                  Clear
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
